import React from 'react';
import Views from '.';
import ProgressBar from './progressbar';

const ProgressBarView = ({title, left, ...props}) => {
  return (
    <Views title={title} left={left}>
      <ProgressBar {...props} />
    </Views>
  );
};

export default ProgressBarView;
